export default __webpack_public_path__ + "static/media/nuk-pro-buildings.651576ab.png";